module.exports = __webpack_public_path__ + "img/instagram-griss-logo-16x16.2799a66b.svg";